import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';

// import { Link } from 'react-router-dom';

export default class QuestionSingleChoice extends Component {
	static propTypes = {
		oQuestion: PropTypes.object.isRequired
	}

	constructor(props) {
		super(props);

		this.handleAnswerQuestion = this.handleAnswerQuestion.bind(this);
		this.renderAnswer = this.renderAnswer.bind(this);

		this.keyCount = 0;
		this.getKey = this.getKey.bind(this);
	}

	getKey() {
		return this.keyCount++;
	}

	/**
	 * Handle it
	 * @param answer
	 */
	handleAnswerQuestion(answer) {
		this.props.onAnswerQuestion(answer);
	}



	breakLine(text) {
		var br = React.createElement("br");
		var regex = /(<br \/>)/g;
		return text.split(regex).map(function(line, index) {
		  return line.match(regex) ? <br key={"key_" + index} /> : line;
		});
	  }



	renderAnswer(answer) {
		const onClick = () => {
			this.handleAnswerQuestion(answer);
		};

		const style = {
			paper: {
				marginTop: "15px",
				padding: "15px",
				backgroundColor: answer.backgroundColor,
			},
			text: {
				color: answer.fontColor
			}
		}

		const styledAnswer = this.breakLine(answer.answer);

		return (
			<div className='col-12' key={this.getKey()} onClick={onClick}>
				<Paper style={style.paper} elevation={4}>
					{/*<Typography style={style.text} variant="headline" component="h3">*/}
						{/*{answer.answer}*/}
					{/*</Typography>*/}
					<Typography style={style.text} component="p">
						{styledAnswer}
					</Typography>
				</Paper>
			</div>
		);
	}



	render() {
		const {oQuestion} = this.props;

		return (
			<section className='section QuestionSingleChoice'>
				<div className='container situation'>
					<div className="row situation">
						<div className="col-12 situation-question">
							<Typography variant="headline" style={{fontSize: "18px", marginTop: "5px"}}>
								{this.breakLine(oQuestion.question)}
							</Typography>
							<Typography component="p" style={{marginTop: "15px", marginBottom: "15px"}}>
								{oQuestion.help}
							</Typography>
						</div>
					</div>
					<div className="row situation-answers">
						{
							oQuestion.answers.map(answer => {
								return this.renderAnswer(answer);
							})
						}
					</div>
					<div className="col-12 situation-category">
							<Typography variant="question-category" style={{fontSize: "15px", marginTop: "20px"}}>
								{oQuestion.questionCategory}
							</Typography>
						</div>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/QuestionSingleChoice.jsx